import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Combine class names with tailwind-merge semantics (later classes win on conflict). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
